import 'src/styles/ui/resource-header.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * ResourceHeader Component - Flexible header component for panels
 *
 * @param {Object} props
 * @param {Object} props.icon - FontAwesome icon to display on the left (optional)
 * @param {React.ReactNode} props.children - Content area (title, subtitle, etc.)
 * @param {React.ReactNode} props.action - Right-side action element (link, button, etc.)
 * @param {string} props.className - Additional CSS classes
 */
const ResourceHeader = ({ icon, children, action, className, ...props }) => {
  const headerClasses = classNames('panel-header', className);

  return (
    <div className={headerClasses} {...props}>
      {icon && (
        <div className='panel-header__icon'>
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
      {children && <div className='panel-header__content'>{children}</div>}
      {action && <div className='panel-header__action'>{action}</div>}
    </div>
  );
};

ResourceHeader.propTypes = {
  icon: PropTypes.object,
  children: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};

ResourceHeader.defaultProps = {
  icon: null,
  children: null,
  action: null,
  className: '',
};

export default ResourceHeader;
